var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F548F",
    d: "M32 0H0v32h32V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m-2.3 31.37 2.93 2.94L34.31.63 31.37-2.3-2.3 31.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m31.37 34.3 2.94-2.93L.63-2.31-2.3.63l33.68 33.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "m15.07 15.01.96.96L32.83-.84l-.95-.96L15.07 15ZM-2.14 34.19l.96.96 18.16-18.16-.96-.96-18.16 18.16ZM14.34 16.28l.96-.96L-1.5-1.49l-.96.96 16.81 16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "m33.52 33.48.96-.96-18.16-18.16-.96.96 18.16 18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M-1.52 11.8v8.39h35.04V11.8H-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M20.2-1.84H11.8v35.68h8.39V-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M-1.52 13.92v4.16h35.04v-4.16H-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M18.08-1.84h-4.16v35.68h4.16V-1.84Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.b3ffd659ef1d6e0d75f46946e60d8078.svg";
export { ForwardRef as ReactComponent };